import PropTypes from 'prop-types';

const Button = ({ label, priority = 'tertiary', inverse = false, type = 'button', onClick = undefined, disabled = false, className = undefined }) => {
  return (
    <button
      type={type}
      className={`button  ${inverse ? 'button--inverse' : ''}  button--${priority}  ${className ? className : ''}`}
      onClick={onClick}
      disabled={disabled}
    >
      {label}
    </button>
  );
}

Button.propTypes = {
  label: PropTypes.string.isRequired,
  priority: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
  inverse: PropTypes.bool,
  type: PropTypes.oneOf(['button', 'submit']),
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string
}

export default Button;
